"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserGroupForm = void 0;
const T = __importStar(require("@microsoft/fast-element"));
require("./template.html");
const client_1 = require("@rws-framework/client");
const component_1 = require("@front/components/site-menu/component");
//@ts-ignore                
let rwsTemplate = T.html `<template>
    <div class="container-fluid">
        <div class="user-group-form-page">
            <div class="row">
                <div class="col-lg-8 col-12 pb-lg-5">

                    <div class="mb-2">
                        <h1>${x => x.userGroupId ? 'userGroup.form.title.edit'.t() : 'userGroup.form.title.add'.t()}
                        </h1>
                        <div class="text-zero top-right-button-container">
                            <button @click="${(x, c) => x.goBack()}" type="button"
                                class="top-right-button mr-1 btn btn-primary btn-lg">${'userGroup.form.back'.t()}</button>
                        </div>
                    </div>
                    <div class="card card-body mb-5">
                        <user-group-form-content :userGroupId="${x => x.userGroupId}" :isModalMode="${() => false}"></user-group-form-content>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>`;
require("./styles/layout.scss");
const styles = T.css `.user-group-form-page .top-right-button-container {
  position: absolute;
  top: 0;
  right: 15px;
  z-index: 10;
}
.user-group-form-page .card {
  border: 1px solid #dee2e6;
  border-radius: 0.375rem;
}
.user-group-form-page .form-group {
  margin-bottom: 1.5rem;
}
.user-group-form-page h5 {
  color: #495057;
  font-weight: 600;
  margin-bottom: 1rem;
}`;
const shadowOptions = { "mode": "open" };
let UserGroupForm = class UserGroupForm extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.userGroupId = null;
    }
    async connectedCallback() {
        this.userGroupId = this.routeParams.id;
        super.connectedCallback();
    }
    goBack() {
        component_1.SiteMenu.goto.bind(this)('/user-group/list');
    }
};
exports.UserGroupForm = UserGroupForm;
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], UserGroupForm.prototype, "userGroupId", void 0);
exports.UserGroupForm = UserGroupForm = __decorate([
    (0, client_1.RWSView)('user-group-form', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], UserGroupForm);
UserGroupForm.defineComponent();
